import { getSearchPrdSuggestions } from "../../services/MainService";
const state = {
  searchPrdSuggestions: [],
};
const getters = {
  allPrdSuggestions: (state) => state.searchPrdSuggestions,
};
const actions = {
  async fetchPrdSuggestions({ commit }, val) {
    await getSearchPrdSuggestions(val)
      .then((res) => res.data)
      .then((res) => {
        commit("setProductsSuggestions", res);
      });
  },
};
const mutations = {
    setProductsSuggestions: (state, searchPrdSuggestions) =>
    (state.searchPrdSuggestions = searchPrdSuggestions),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
